<template>
    <div class="wrapper">
        <div class="my-header">
            <van-nav-bar
                    title="我的报备列表"
                    left-text="返回"
                    left-arrow
                    @click-left="onClickLeft"
                    @click-right="showSearch = true"
            >
                <van-icon name="search" slot="right" />
            </van-nav-bar>
<!--            <BaseHeader :title="'我的报备列表'" :show="true" @handleSearch="showSearch = true"/>-->
            <div class="search-content">
                <van-popup v-model="showSearch" position="top">
                    <div class="search-box">
                        <div class="item">
                            <van-field v-model="searchInfo.shopName" label="商家名称" placeholder="请输入商家名称"/>
                        </div>
                        <div class="item">
                            <van-field v-model="searchInfo.contactsTel" label="联系人电话" placeholder="请输入联系人电话"/>
                        </div>
                        <van-button type="primary" size="large" @click="handleSearch">搜索</van-button>
                    </div>
                </van-popup>
            </div>
        </div>
        <div class="search-date">
            <TheSearchByDate :total="total" @handleChangeDate="handleChangeDate"/>
        </div>
        <div class="content">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
                <div v-for="item in shopList" :key="item.id" class="shop-item" @click="handleGoDetails(item.id,item.status,item.business_examine)">
                    <p style="font-size: 16px">{{ item.shop_name }}</p>
                    <p>商家电话：{{ item.shop_tel }}</p>
                    <p>商家地址：{{ item.address_show }}</p>
                    <p>联系人名称：{{ item.contacts_name }}</p>
                    <p>联系人电话：{{ item.contacts_tel }}</p>
                    <p style="color: #59DFE2">报备时间：{{ item.created_at }}</p>
                    <div class="status">
                        <span v-if="item.status === 0" style="background: #E62E25">未签约</span>
                        <span v-if="item.status === 1 && item.business_examine === 0" style="background: #1871F8">审核中</span>
                        <span v-if="item.status === 1 && item.business_examine === 1" style="background: #4EBA4E">已签约</span>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import BaseHeader from "../components/BaseHeader";
    import {getPrepareListService} from "../service/salesmanService";
    import {Toast} from 'vant';
    import {mapState} from 'vuex';
    import TheSearchByDate from "../components/TheSearchByDate";
	//import {wecharShare} from "../util/weChat.js";

    export default {
        name: "SalesmanMyPrepareList",
        data(){
            return{
                offset:{
                    page:0,
                    limit:10,
                },
                loading: false,//加载中动画
                finished: false,//加载是否完成
                showSearch:false,
                searchInfo:{//搜索条件
                    shopName:'',//店铺名称
                    contactsTel:'',//联系人电话
                },
                shopList:[],
                total:0,//总计
                temp:0,
            }
        },
		mounted() {
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
		},
        methods:{
            onClickLeft(){
                this.$router.go(-1)
            },
            //改变筛选条件
            handleChangeDate(startDate,endDate){
                this.startDate = startDate;
                this.endDate = endDate;
                this.total = 0;
                this.offset.page = 0;
                this.shopList = [];
                // this.temp = 2;
                this.loading = false;
                this.finished = false;
                this.getData();

            },


            //加载数据
            getData(){
                if(!this.saleId){
                    Toast('业务员信息获取失败，请联系管理员');
                    return;
                }

                // if(this.temp === 0){
                //     this.temp ++;
                //     return;
                // }
                this.offset.page++;

                getPrepareListService(this.searchInfo.shopName,this.searchInfo.contactsTel,this.offset.page,this.offset.limit,this.saleId,this.startDate,this.endDate).then(res => {
                    if(res.status === 1){
                        this.loading = false;
                        if(res.datas.datas.length === 0){
                            this.finished = true;
                            return;
                        }
                        if(res.datas.datas.length > 0){
                            this.total = res.datas.sum_num;
                        }
                        this.shopList = [... this.shopList,...res.datas.datas];
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            //搜索
            handleSearch(){
                this.showSearch = false;
                this.shopList = [];
                this.offset.page = 1;
                this.getData();
            },

            /**
             * 查看报备详情
             * @param shopId 商家ID
             * @param stateSigning 是否签约 0是未签约，1是已签约
             * @param stateExamine 审核状态  0是未审核，1是已审核
             */
            handleGoDetails(shopId,stateSigning,stateExamine){
                this.$router.push({
                    name:'salesmanPrepareDetails',
                    params : {
                        shopId,
                        stateSigning,
                        stateExamine,
                    }
                })
            }
        },
        computed:{
            ...mapState({
                saleId: state => state.userInfo.saleId,
            })
        },
        components:{
            BaseHeader,
            TheSearchByDate

        },

    }
</script>

<style scoped lang="scss">
    .wrapper{
        background: #FFFFFF!important;
        .header{
            .search-content{
                .search-box{
                    padding: 10px;
                    box-sizing: border-box;
                }
            }
        }
        .content{
            background: #FFFFFF!important;
            padding: 20px 15px;
            box-sizing: border-box;
            .shop-item{
                background: #ffffff;
                padding: 10px;
                box-sizing: border-box;
                position: relative;
                margin-bottom: 20px;
                border-radius: 10px;
                box-shadow:0px 3px 17px 1px rgba(203,201,197,0.23);
                overflow: hidden;
                p{
                    padding: 5px 0;
                }
                .status{
                    position: absolute;
                    top: 7px;
                    right: -21px;
                    transform: rotate(45deg);
                    span{
                        padding: 5px 20px;
                        box-sizing: border-box;
                        color: #ffffff;
                    }
                }
            }
        }
    }
</style>